$(".toggle-btn, .close-btn").click(function () {
    $("body").toggleClass("menu-open");
    if ($("body").hasClass("menu-open")) {
        $("body").css("overflow", "hidden"); 
    } else {
        $("body").css("overflow", "");
    }
});